module.exports = __webpack_public_path__ + "img/image18.eecbdf96.webp";